
import { defineComponent, ref, onMounted, computed } from 'vue'
import { useRoute } from 'vue-router';
import RepmanService from '@/core/services/RepmanService';
import { errManager, showNotification } from "@/core/config/Tools";
import moment from "moment";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { useI18n } from "vue-i18n/index";

//componentes
import AddRepman from '../modals/AddRepmanModal.vue';

export default defineComponent({
    name: "manager-clubs-repman",
    components: { AddRepman },
    setup() {
        const { t } = useI18n();
        const route = useRoute();
        const { id } = route.params;
        const loader = ref(false);
        const search = ref("");
        const listRepam = ref<any>([]);
        const modalAddRepmanRef = ref<any>(null);

        const openModal = () => {
            if (modalAddRepmanRef.value) {
                modalAddRepmanRef.value.openModal();
            }
        };

        const getListRepman = async () => {
            loader.value = true
            await RepmanService.getData({ idclub: id })
                .then((res) => {
                    listRepam.value = res.data
                    loader.value = false
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        };

        const filteredList = computed(() => {
            return listRepam.value.filter(
                (item) => item.person.toLowerCase().includes(search.value.toLowerCase())
            );
        });

        const onChangeStatus = (row, label: string, status: number) => {
            Swal.fire({
                title: `${label}`,
                html: `${label} a <b>${row?.person}</b> ${t('permanently')}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: `${t('yes')}, ${label.toLowerCase()}`,
                cancelButtonText: t('cancel'),
                confirmButtonColor: "#d33",
                showLoaderOnConfirm: true,
                reverseButtons: true,
                preConfirm: () => {
                    return RepmanService.update(row.idrepman, 'change-status', { status: status, label: label })
                        .then((res) => {
                            return res.data
                        }).catch(({ response }) => {
                            Swal.showValidationMessage(
                                `Request failed: ${response}`
                            )
                        })
                },
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    showNotification(result.value)
                    result.value.status === 'success' && getListRepman();
                }
            })
        };

        const onResponse = (data: any) => {
            if (!data) return;
            if (data.status == 'success') getListRepman()
        }

        onMounted(() => {
            getListRepman();
        });

        return {
            t,
            id,
            loader,
            search,
            moment,
            listRepam,
            filteredList,
            modalAddRepmanRef,
            //events
            getListRepman,
            onChangeStatus,
            openModal,
            onResponse
        }

    },
})
